<template>
  <div class="aboutUs">
    <div class="top">
      <img src="@/assets/images/bg/concatUs.png" alt="" />
      <div class="title topText">耀德守纲·客安如磐</div>
    </div>
    <div class="title">关于我们</div>
    <header>
      <div class="left">
        <div class="explanation">
          <p>
            “耀德” :
            源自《国语》“耀德不观兵”，意为显扬道德而非武力征服。耀客物联将其引申为以技术之光彰显商业伦理。
          </p>
          <p>
            “守纲”：化用“纲举目张”，指严守行业规范与安全准则。耀客物联主导制定实验室安全团体标准、出版教材，将“纲”具象化为行业技术规范与道德底线。
          </p>
          <p>
            “如磐”:取自成语“安如磐石”，喻指安全稳固不可动摇。耀客物联以智能安全柜等技术实现“磐石级”防护。
          </p>
          <div class="numInfo">
            <div class="num" v-for="(item, index) in NUM_LIST" :key="index">
              <div class="numNum">{{ item.num }}</div>
              <div class="numTitle">{{ item.title }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <OssImg src="images/aboutUs/handsome.png" alt="" />
      </div>
    </header>
    <!-- 发展历程 -->
    <div class="title">发展历程</div>
    <nav>
      <img src="@/assets/images/bg/developmentHistory.png" alt="" />
    </nav>
    <div class="title">公司文化</div>
    <main>
      <div class="culture">
        <div v-for="(item, index) in COMPANY_CULTURE" :key="index" class="c-t">
          <div class="cultureItem">
            <div class="cultureImg">
              <OssImg :src="item.imgPath" alt="" />
            </div>
            <div class="cultureTitle">{{ item.title }}</div>
            <div class="desc">
              <span
                style="margin-right: 15px"
                v-for="(ele, index2) in item.cultureList"
                :key="index2"
              >
                {{ ele }}
              </span>
            </div>
          </div>
          <div class="line" v-if="index !== COMPANY_CULTURE.length - 1"></div>
        </div>
      </div>
    </main>
    <div class="title">公司资质</div>
    <div class="qualifications">
      <CompanyQualifications></CompanyQualifications>
    </div>
    <div class="title">联系我们</div>
    <footer>
      <OssImg src="/UIV3/map.png" alt="" />
      <div style="margin: 32px 0px 8px 0px">
        地址:武汉市东湖新技术开发区珞喻东路4号慧谷时空1栋26层01号
      </div>
      <div style="margin-bottom: 56px">电话：400-966-5960</div>
    </footer>
  </div>
</template>

<script setup>
import { ref } from "vue";
import CompanyQualifications from "@/components/CompanyQualifications.vue";
const NUM_LIST = ref([
  { num: "100+", title: "产权荣誉" },
  { num: "200+", title: "交付客户数" },
  { num: "20+", title: "公司运营(省)" },
  { num: "5300+", title: "累计交付(台)" },
]);

const COMPANY_CULTURE = ref([
  {
    imgPath: "/UIV3/culture1.png",
    cultureList: ["客户至上", "诚信守正", "开拓创新", "高效严谨"],
    title: "价值观",
  },
  {
    imgPath: "/UIV3/culture2.png",
    cultureList: ["提高实验室安全管控水平，为教育和科研事业发展保驾护航"],
    title: "使命",
  },
  {
    imgPath: "/UIV3/culture3.png",
    cultureList: [
      "成为全球领先的实验室安全智能化解决方案引领者，构建零事故的科研生态",
    ],
    title: "愿景",
  },
]);
</script>

<style lang="scss" scoped>
.aboutUs {
  $titleSize: 2.5rem;
  width: 100%;
  max-width: none;
  font-family: "PingFang SC";
  // background: rgba(247, 248, 250, 1);
  padding: 0 0 20px 0px;
  .top {
    margin-top: 20px;
    position: relative;
    img {
      width: 100%;
    }
    .topText {
      position: absolute;
      top: 39%;
      left: 11%;
    }
  }
  .title {
    color: rgba(33, 33, 33, 1);
    font-weight: 700;
    font-size: $titleSize;
    text-align: center;
  }
  header {
    margin-top: 48px;
    display: flex;
    justify-content: center;
    gap: 52px;
    .left {
      width: 37rem;
      display: flex;
      align-items: center;
      .explanation {
        color: rgba(66, 66, 66, 1);
        font-weight: 500;
        margin-bottom: 24px;
        text-indent: 2em;
        .numInfo {
          display: flex;
          justify-content: space-evenly;
          margin-top: 24px;
          .num {
            .numNum {
              color: rgba(33, 33, 33, 1);
              font-weight: 600;
              font-size: 36px;
              margin-bottom: 16px;
            }
            .numTitle {
              color: rgba(136, 136, 136, 1);
              font-weight: 500;
              font-size: 14px;
            }
          }
        }
      }
    }
    .right {
      width: 30%;
      img {
        width: 100%;
      }
    }
  }
  nav {
    margin: 0px 0px;
    width: 100%;
    img {
      width: 100%;
    }
  }
  main {
    margin: 48px 0px;
    display: flex;
    justify-content: center;
    .culture {
      width: 60%;
      height: 224px;
      // background: rgba(255, 255, 255, 1);
      display: flex;
      justify-content: center;
      gap: 10px;
      align-items: center;
      .c-t {
        width: 100%;
        display: flex;
        align-items: center;
        .cultureItem {
          width: 100%;
          height: 165px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
          .cultureTitle {
            font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
            font-weight: bold;
            font-size: 16px;
            color: #424242;
            margin: 10px 0px;
          }
          .cultureImg {
            width: 80px;
            height: 80px;
            border-radius: 80px;
            text-align: center;
            line-height: 105px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .desc {
            height: 50px;
          }
          span {
            font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
            font-weight: 500;
            font-size: 14px;
            color: #888888;
          }
        }
        .line {
          width: 2px;
          height: 148px;
          background: #32a89e;
          border-radius: 0px 0px 0px 0px;
          margin: 0px 15px;
        }
      }
    }
  }
  footer {
    margin-top: 32px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
    font-weight: 500;
    font-size: 14px;
    color: #424242;
    img {
      width: 80%;
    }
  }
}
</style>
